import React, { useEffect, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import Modal from "../Components/Modal";
import CollapseCard from "../Components/CollapseCard";
import { useToast } from "../Components/toast/ToastProvider";
import { getALLFixedDestinations, saveFixedDestination } from "../Service/FixedDestinationService";
import FixedDestinationForm from "../Components/FixedDestinationForm";
import FixedDestinationList from "../Components/FixedDestinationList";

const FixedDestinationPage = () => {
    const [fixedDestinationData, setFixedDestinationData] = useState([]);
    const [fixedDestinationForm, setFixedDestinationForm] = useState({ title: "" });
    const [showModal, setShowModal] = useState(false);
    const toast = useToast();

    useEffect(() => {
        fetchDestination()
    }, [])

    const fetchDestination = async () => {
        try {
            const res = await getALLFixedDestinations()
            setFixedDestinationData(res.data);
        } catch (err) {
            alert(err.message || "Failed to fetch Fixed Destinations")
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!fixedDestinationForm.title) return alert('Please fill the destinations name')

            const duplicateName = fixedDestinationData.some((item)=>item.id !== fixedDestinationForm.id && item.title.trim().toLowerCase() === fixedDestinationForm.title.trim().toLowerCase());

            if(duplicateName){
                toast("Fixed Destination Name already exist","ERROR");
                return;
            }
        try {
            const payload = fixedDestinationForm.id ? { id: fixedDestinationForm.id, title: fixedDestinationForm.title } :
                { title: fixedDestinationForm.title }
            await saveFixedDestination(payload)
            toast(fixedDestinationForm.id ? 'Fixed Destinations update successfully' : 'Fixed Destinations added successfully', "SUCCESS")
            fetchDestination()
            handleCancel()
        } catch (err) {
            toast(err.message || 'Failed to save Fixed Destinations', "ERROR")
        }
    };

    const handleEdit = (item) => {
        setFixedDestinationForm({ id: item.id, title: item.title });
        setShowModal(true);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFixedDestinationForm((prev) => ({ ...prev, [name]: value }));
    };


    // const handleDelete = async (index) => {
    //   if (!window.confirm("Are you sure you want to delete this fixed destination?")) return
    //   try {
    //     await deleteDestination(fixedDestinationData[index].id)
    //     toast('Fixed Destinations deleted successfully', "SUCCESS")
    //     fetchDestination()
    //   } catch (err) {
    //     alert(err.message || "Failed to delete source", "ERROR")
    //   }
    // };

    const handleCancel = () => {
        setFixedDestinationForm({ title: "" });
        setShowModal(false);
    };

    return (
        <Main>
            <PageContainer
                titlePage="Fixed Destination"
                buttonText={"ADD"}
                onButtonClick={() => {
                    setShowModal(true);
                }}
            >
                <Modal
                    visible={showModal}
                    size="lg"
                    onClose={handleCancel}
                    headerText={fixedDestinationForm.id ? "Edit Fixed Destination" : "Add Fixed Destination"}
                >
                    <FixedDestinationForm
                        handleChange={handleChange}
                        fixedDestinationForm={fixedDestinationForm}
                        handleSubmit={handleSubmit}
                        handleCancel={handleCancel}
                    />
                </Modal>

                <CollapseCard title='Fixed Destination'>
                    <FixedDestinationList
                        fixedDestinationData={fixedDestinationData}
                        handleEdit={handleEdit}
                    // handleDelete={handleDelete}
                    />
                </CollapseCard>
            </PageContainer>
        </Main>
    );
};

export default FixedDestinationPage;
